import { Dispatch, SetStateAction, createContext } from 'react';
import { DataRoomDashboardStats, DealRoom } from 'models/DealRoom';
import { Listing, ListingEnquiry } from 'models/Listing';
import { DropzoneDelete, DropzoneUpload } from 'models/Dropzone';
import { Lead, LeadState } from 'models/Lead';
import { DropzoneFile } from 'components/Dropzone/utils';
import utils from 'utils';

export type WorkflowConfigurationStep = {
  maxCapacity: number;
  step: LeadState;
};

export type WorkflowConfiguration = {
  _id: string;
  workflowConfigurationSteps: WorkflowConfigurationStep[];
};

export type WorkflowConfigurationStepsCapacity = Record<LeadState, number>;

type ListingContextProps = {
  listing: Partial<Listing>;
  dealRoom: DealRoom;
  gallery: DropzoneFile[];
  enquiry: Partial<ListingEnquiry>;
  workflowConfigurationStepsCapacity: WorkflowConfigurationStepsCapacity;
  dashboardStats: DataRoomDashboardStats;
  isTableView: boolean;
  isUploading: boolean;
  workflowConfiguration: WorkflowConfiguration;
  areActionsDisabled: boolean;
  canManageDeal: boolean;
  hasUnlockPremiumFeatures: boolean;
  statsIsFetching: boolean;
  canAccessDataRoom: boolean;
  isListingOwner: boolean;
  isTransferringDeal: boolean;
  leads: Partial<Lead>[];
  refetchLeads: () => void;
  onTransferToEnterpriseColleague: (
    userId: string,
    userFullName: string,
  ) => Promise<{
    isSuccessfully: boolean;
  }>;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setListing: Dispatch<SetStateAction<Partial<Listing>>>;
  setEnquiry: Dispatch<SetStateAction<Partial<ListingEnquiry>>>;
  setDealRoom: Dispatch<SetStateAction<DealRoom>>;
  updateGallery: (images: DropzoneFile[]) => void;
  deleteListingFile: DropzoneDelete;
  uploadListingFile: DropzoneUpload;
};

export default createContext<Partial<ListingContextProps>>({
  listing: null,
  gallery: [],
  enquiry: null,
  workflowConfiguration: null,
  workflowConfigurationStepsCapacity: null,
  dashboardStats: null,
  isTableView: false,
  isUploading: false,
  areActionsDisabled: false,
  canManageDeal: true,
  hasUnlockPremiumFeatures: false,
  statsIsFetching: false,
  canAccessDataRoom: false,
  isListingOwner: false,
  isTransferringDeal: false,
  leads: [],
  refetchLeads: utils.noop,
  onTransferToEnterpriseColleague: utils.noop,
  setListing: utils.noop,
  setEnquiry: utils.noop,
  setDealRoom: utils.noop,
  updateGallery: utils.noop,
  setIsUploading: utils.noop,
});
